import { Heart, Mail } from "lucide-react";
import { useLang } from "@/i18n";
import { FadeUp } from "@/components/motion";
import { L } from "@/components/L";

export const SupportCta = ({ title, text }) => {
  const { t } = useLang();
  return (
    <section className="py-20 sm:py-28" data-testid="support-cta">
      <div className="wrap">
        <FadeUp className="relative overflow-hidden bg-[var(--yellow)] rounded-[3rem_3rem_3rem_0.6rem] p-8 sm:p-14 lg:p-16 grid gap-8 lg:grid-cols-12 items-center">
          <div aria-hidden="true" className="absolute -right-12 -bottom-12 w-48 h-48 petal-tl bg-[var(--coral)]" />
          <div className="relative lg:col-span-8">
            <h2 className="text-4xl sm:text-5xl leading-tight">{title || t.home.donateTitle}</h2>
            <p className="mt-4 text-lg text-[var(--ink)]/80 max-w-xl">{text || t.donate.intro}</p>
          </div>
          <div className="relative lg:col-span-4 flex flex-wrap gap-3 lg:justify-end">
            <L to="donate" className="btn btn-primary" data-testid="support-cta-donate"><Heart size={16} /> {t.nav.donateNow}</L>
            <L to="contact" className="btn btn-ghost" data-testid="support-cta-info"><Mail size={16} /> {t.common.requestInfo}</L>
          </div>
        </FadeUp>
      </div>
    </section>
  );
};
